export default [
      {
          path:'/',
          name:'shouye',
          component:() => import('@/views/shouye')
      },
]


// WEBPACK FOOTER //
// ./src/router/shouye.js